import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DialogMUI, { DialogProps } from '@material-ui/core/Dialog';
import DialogContentMUI, { DialogContentProps as DialogContentPropsMUI } from '@material-ui/core/DialogContent';

import Typography from '../typography';
import CloseButton from '../close-button';
import { BoxProps } from '../box';
import {
	HeaderRoot,
	FooterRoot,
} from './styled';


export type DialogBaseProps = {
	isOpen: boolean;
} & Omit<DialogProps, 'open'>;

const DialogBase: React.SFC<DialogBaseProps> = (props) => {
	const { isOpen, ...rest } = props;

  return (
		<DialogMUI
			open={isOpen}
			disableBackdropClick
			PaperProps={{
				square: true,
			}}
			{...rest}
		/>
  );
}

export type DialogHeaderProps = {
	onClose: () => void;
}

const DialogHeader: React.SFC<DialogHeaderProps> = (props) => {
	const {
		children,
		onClose,
	} = props

	return (
		<HeaderRoot>
			<Typography.Title>{children}</Typography.Title>
			<CloseButton onClick={onClose} />
		</HeaderRoot>
	);
};

export type DialogContentProps = {
	style?: React.CSSProperties;
} & DialogContentPropsMUI;

const DialogContent = withStyles(() => ({
  root: {
    padding: '24px 20px',
  },
}))((props: DialogContentProps) => <DialogContentMUI dividers {...props} />);


export type DialogFooterProps = {} & BoxProps;

const DialogFooter: React.SFC<DialogFooterProps> = ({ children, ...rest }) => {
	return (
		<FooterRoot {...rest}>
			{children}
		</FooterRoot>
	);
};

const Dialog = {
	Base: DialogBase,
	Header: DialogHeader,
	Content: DialogContent,
	Footer: DialogFooter,
};

export default Dialog;
